import { ModelRegistry } from 'ember-data/model';

export enum ApiCredentialType {
  App = 'app',
  Tracking = 'tracking',
  WebhookSigning = 'signing',
}

const API_KEY_TYPE_INTERFACE: Record<string, { modelName: keyof ModelRegistry; uiText: Record<string, string> }> = {
  app: {
    modelName: 'ext-api-key',
    uiText: {
      createButtonText: 'Create App API Key',
      description: 'These keys allow you to send data to the App API. They do not provide access to the Track API.',
      title: 'App API Keys',
    },
  },
  tracking: {
    modelName: 'api-credential',
    uiText: {
      createButtonText: 'Create Track API Key',
      description:
        'These keys allow you to send data to any of the Tracking APIs as well as configure the JavaScript snippet. They do not provide access to the App API.',
      title: 'Track API Keys',
    },
  },
  signing: {
    modelName: 'signing-secret',
    uiText: {
      description:
        'Securely verify that webhooks requests are being sent from Customer.io. Instructions on how to verify requests are available <a href="https://customer.io/docs/webhooks-action/#securely-verify-requests" target="_blank" rel="noopener noreferrer">in our documentation</a>.',
      title: 'Webhook Signing Key',
    },
  },
};

export default API_KEY_TYPE_INTERFACE;
